const COOKIE_KEY = '.t';

const getCookie = function (cname: string) {
	const name = cname + "=";
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');
	for (let c of ca) {
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

const isLoggedIn = () => {
	return !!getCookie(COOKIE_KEY);
};

const doesTokenHaveRole = (role: string) => {
	const roleInCookie: any = getCookie(COOKIE_KEY);
	if (!roleInCookie) return false;

	return roleInCookie.toUpperCase() === role.toUpperCase();
};


export default {
	isLoggedIn,
	doesTokenHaveRole
};
